import { omit } from "lodash";

import { LightboxConfiguration } from "@/components/Interface/Lightbox/Lightbox";

export const CARD_PROVIDERS_REQUIRING_3DS = ["ECA", "VIS"];

export const isCardholderNameMissing = (
  paymentProvider: string | undefined,
  cardholderName: string,
): boolean =>
  CARD_PROVIDERS_REQUIRING_3DS.includes(paymentProvider ?? "") &&
  !cardholderName;

export const get3DsBrowserInfo = () => ({
  browserScreenHeight: screen.height,
  browserScreenWidth: screen.width,
  browserLanguage: navigator.language,
  browserTZ: Intl.DateTimeFormat().resolvedOptions().timeZone,
});

export interface LightboxConfigurationWithAmount extends LightboxConfiguration {
  amount?: number;
}

export const filterConfigurationForParams: (
  config: LightboxConfigurationWithAmount,
) => Exclude<
  LightboxConfigurationWithAmount,
  { version: string; production: string }
> = (config) =>
  Object.entries(omit(config, ["version", "production"])).reduce(
    (prev, [key, value]) => ({
      ...prev,
      [key]: Array.isArray(value) ? value.join(",") : value,
    }),
    { amount: 0 } as LightboxConfigurationWithAmount,
  );
